import React from 'react';
import './NextButton.css';

interface NextButtonProps {
  onClick: () => void;
  text?: string;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'secondary';
  size?: 'normal' | 'large';
  className?: string;
}

const NextButton: React.FC<NextButtonProps> = ({
  onClick,
  text = "Next",
  disabled = false,
  loading = false,
  variant = 'primary',
  size = 'large',
  className = ''
}) => {
  const handleClick = () => {
    if (!disabled && !loading) {
      onClick();
    }
  };

  return (
    <button
      className={`next-button ${variant} ${size} ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-label={loading ? 'Loading...' : text}
    >
      <span className="button-content">
        {loading ? (
          <>
            <div className="spinner" />
            <span className="button-text">Loading...</span>
          </>
        ) : (
          <>
            <span className="button-text">{text}</span>
            <div className="arrow-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path 
                  fill="currentColor" 
                  d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                />
              </svg>
            </div>
          </>
        )}
      </span>
    </button>
  );
};

export default NextButton;